import { render, staticRenderFns } from "./ComparativasTech.vue?vue&type=template&id=64d6278e&scoped=true"
import script from "./ComparativasTech.vue?vue&type=script&lang=js"
export * from "./ComparativasTech.vue?vue&type=script&lang=js"
import style0 from "./ComparativasTech.vue?vue&type=style&index=0&id=64d6278e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6278e",
  null
  
)

export default component.exports